var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreparation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f7931a;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 80,
    height: 80,
    rx: 16,
    ry: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.57,61.93h-30.43c-1.18,0-2.13-.95-2.13-2.13v-30.43c0-1.18.95-2.13,2.13-2.13h29.39c1.75,0,3.18,1.42,3.18,3.18v29.39c0,1.18-.95,2.13-2.13,2.13Zm-27.43-3h24.43c1.18,0,2.13-.95,2.13-2.13v-23.39c0-1.75-1.42-3.18-3.18-3.18h-23.39c-1.18,0-2.13.95-2.13,2.13v24.43c0,1.18.95,2.13,2.13,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.17,54.54h0c-.83,0-1.5-.67-1.5-1.5v-26.15c0-1.4-1.14-2.54-2.54-2.54h-26.15c-.83,0-1.5-.67-1.5-1.5h0c0-.83.67-1.5,1.5-1.5h29.15c1.4,0,2.54,1.14,2.54,2.54v29.15c0,.83-.67,1.5-1.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.5,48.54h0c-.83,0-1.5-.67-1.5-1.5v-26.15c0-1.4-1.14-2.54-2.54-2.54h-26.15c-.83,0-1.5-.67-1.5-1.5h0c0-.83.67-1.5,1.5-1.5h29.15c1.4,0,2.54,1.14,2.54,2.54v29.15c0,.83-.67,1.5-1.5,1.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreparation);
export default __webpack_public_path__ + "static/media/preparation.77b7b671783d4858a503ee5dba1fb1c6.svg";
export { ForwardRef as ReactComponent };